import setting from './setting';
export default {
    getList: ($axios,data)=>{
        return $axios.get(`${setting.http.base_url}/distribuidoras/lista`, {headers:setting.http.headers()});
    },

}
